function asc(x, y) {
  if (x > y) return 1;
  else if (y > x) return -1;
  else return 0;
}

function desc(x, y) {
  if (x < y) return 1;
  else if (y < x) return -1;
  else return 0;
}

export function SortCampaigns(data, sortBy) {
  if (data) {
    data.sort((a, b) => {
      let x, y;

      if (sortBy === "profit") {
        x = parseFloat(a[sortBy]);
        y = parseFloat(b[sortBy]);
      } else {
        x = a[sortBy];
        y = b[sortBy];
      }

      // Descending order : profit & created_at
      // Ascending order	: otherwise
      if (["profit", "created_at"].includes(sortBy)) {
        return desc(x, y);
      } else {
        return asc(x, y);
      }
    });
  }
}
